import { culture as deDE, datepicker as datepicker_deDE } from "./Culture-de-DE.js";
import { culture as enCA, datepicker as datepicker_enCA } from "./Culture-en-CA.js";
import { culture as enGB, datepicker as datepicker_enGB } from "./Culture-en-GB.js";
import { culture as enUS } from "./Culture-en-US.js";
import { culture as esES, datepicker as datepicker_esES } from "./Culture-es-ES.js";
import { culture as frFR, datepicker as datepicker_frFR } from "./Culture-fr-FR.js";
import { culture as itIT, datepicker as datepicker_itIT } from "./Culture-it-IT.js";
import { culture as nlNL, datepicker as datepicker_nlNL } from "./Culture-nl-NL.js";
import { culture as plPL, datepicker as datepicker_plPL } from "./Culture-pl-PL.js";
import { culture as ptBr, datepicker as datepicker_ptBr } from "./Culture-pt-BR.js";
import { culture as ruRU, datepicker as datepicker_ruRU } from "./Culture-ru-RU.js";
import { culture as skSK, datepicker as datepicker_skSK } from "./Culture-sk-SK.js";
import { culture as svSE, datepicker as datepicker_svSE } from "./Culture-sv-SE.js";
import { culture as trTR, datepicker as datepicker_trTR } from "./Culture-tr-TR.js";

export const cultures = {
    "de-DE": deDE,
    "en-CA": enCA,
    "en-GB": enGB,
    "en-US": enUS,
    "es-ES": esES,
    "fr-FR": frFR,
    "it-IT": itIT,
    "pl-PL": plPL,
    "ru-RU": ruRU,
    "sk-SK": skSK,
    "sv-SE": svSE,
    "tr-TR": trTR,
    "pt-BR": ptBr,
    "nl-NL": nlNL,
};

export type CultureSettings = typeof enUS;

ep.cultures = cultures;

/**
 * Sets up datepicker's settings for all supported cultures.
 */
export const setupDatepickerRegionalSettings = () => {
    $.datepicker.regional["de-DE"] = datepicker_deDE;
    $.datepicker.regional["en-CA"] = datepicker_enCA;
    $.datepicker.regional["en-GB"] = datepicker_enGB;
    $.datepicker.regional["es-ES"] = datepicker_esES;
    $.datepicker.regional["fr-FR"] = datepicker_frFR;
    $.datepicker.regional["it-IT"] = datepicker_itIT;
    $.datepicker.regional["pl-PL"] = datepicker_plPL;
    $.datepicker.regional["ru-RU"] = datepicker_ruRU;
    $.datepicker.regional["sk-SK"] = datepicker_skSK;
    $.datepicker.regional["sv-SE"] = datepicker_svSE;
    $.datepicker.regional["tr-TR"] = datepicker_trTR;
    $.datepicker.regional["pt-BR"] = datepicker_ptBr;
    $.datepicker.regional["nl-NL"] = datepicker_nlNL;
};
